if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      const opener = this.openedBy;
      const x = this._savedScrollX ?? window.scrollX;
      const y = this._savedScrollY ?? window.scrollY;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      super.hide();

      const restore = () => {
        window.scrollTo(x, y);
        this.restoreGallery(opener);
      };
      restore();
      requestAnimationFrame(restore);

      if (!isMobile && opener && typeof opener.focus === 'function') {
        opener.focus({ preventScroll: true });
      }
    }

    restoreGallery(opener) {
      const slide = opener?.closest('.product__media-item');
      const gallery = opener?.closest('media-gallery') || document.querySelector('media-gallery');
      if (!gallery) return;

      if (slide) {
        gallery.querySelectorAll('.product__media-item.is-active').forEach((item) => {
          if (item !== slide) item.classList.remove('is-active');
        });
        slide.classList.add('is-active');
        const list = slide.parentElement;
        if (list) list.scrollLeft = slide.offsetLeft;
      }

      gallery.querySelectorAll('.product-media-container img').forEach((img) => {
        if (img.naturalWidth === 0 && img.getAttribute('src')) {
          img.src = img.getAttribute('src');
        }
      });
    }

    show(opener) {
      this._savedScrollX = window.scrollX;
      this._savedScrollY = window.scrollY;
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');

      const container = this.querySelector('[role="document"]');
      if (container) {
        container.scrollTop = 0;
        container.scrollLeft = 0;
      }

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
